<p-card>
  <ng-template pTemplate="header">
    <div class="p-card-title p-d-flex">
        <div class="flex-grow-1">{{'component.integrations.connection_info'|translate}}</div>
        <div>
            <p-inputSwitch [(ngModel)]="integration.configuration.enabled"></p-inputSwitch>
        </div>
    </div>
  </ng-template>
  <div class="p-grid" *ngIf="integration.configuration?.enabled">
    <div class="p-col-12 p-field">
      <label for="user">Usuario</label>
      <input [(ngModel)]="integration.configuration.user" id="user" type="text" pInputText name="user" placeholder="" autocomplete="false" disabled />
    </div>
    <div class="p-col-12 p-field">
      <label for="password">{{'component.integrations.configuration.password'|translate}}</label>
      <input [(ngModel)]="integration.configuration.password" id="password" name="password" type="text" pInputText placeholder="" autocomplete="false" disabled />
    </div>
  </div>
</p-card>


<div class="p-col-12 p-d-flex">
  <div class="flex-grow-1"></div>
  <p-button label="{{'general.action.cancel' | translate}}" icon="pi pi-times"
    styleClass="p-button-secondary p-button-text" (click)="cancel()">
  </p-button>
  <button class="p-ml-2" style="float: right;" icon="pi pi-save" pButton type="button"
    label="{{'general.action.save' | translate}}" (click)="save()"></button>
</div>